import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { PopupComponent } from 'src/app/common-layout/popup/popup.component';
import { SubscriptionPlan } from 'src/app/interfaces/plan.interface';
import { NCacheSubscription } from 'src/app/interfaces/subscription.interface';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { BillingTerm } from 'src/app/types/subscription.type';
import { POPUP_MESSAGES } from 'src/app/Util/constants';
import Helper from 'src/app/Util/helper';
import { StorageKeys } from 'src/app/Util/storage-keys';
import StringHelper from 'src/app/Util/string-helper';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-select-plan',
  templateUrl: './select-plan.component.html',
  styleUrls: ['./select-plan.component.sass']
})

export class SelectPlanComponent implements OnInit {

  @Output() updateWizardStep = new EventEmitter();
  @Output() onPlanSelection = new EventEmitter<SubscriptionPlan>();

  @Input() subscriptionPlans: SubscriptionPlan[] = [];
  @Input() selectedPlan: SubscriptionPlan | undefined;
  @Input() isLoadingPlans: boolean = true;
  @Input() subscriptionId:string = ''
  subscription:NCacheSubscription = null
  quotationConfirmationRef: NgbModalRef;
  isSubscriptionLoading : boolean = true
  constructor(
    private router: Router,
    private subscriptionSvc:CloudSubscriptionService,
    private readonly modal: NgbModal,
  ) {}

  ngOnInit(): void {
    this.getSubscriptionDetails()
  }


  onPlanSelected(plan: SubscriptionPlan) {
    this.onPlanSelection.emit(plan);
  }

  onNext() {
    this.updateWizardStep.emit(1);
  }

  isNextAllowed(): boolean {
    return this.selectedPlan != undefined;
  }

  goToDashboard() {
    this.router.navigate([environment.routes.subscription]);
  }

  checkIfPlanNonHosted(plan:SubscriptionPlan){
    return Helper.isPlanNonHosted(plan.planType)
  }

  checkIfPayg(){
    return StringHelper.isPAYG(this.subscription?.billingTerm)
  }

  private getSubscriptionDetails(){
    this.isSubscriptionLoading = true
    this.subscriptionSvc.getSubscriptionDetail(this.subscriptionId).subscribe({
      next:(res)=>{
        this.subscription = res
        this.isSubscriptionLoading = false
      },
      error:(err)=>{
        this.isSubscriptionLoading  = false
      }
    })
  }

 

  





}
